import { z } from 'zod';
/**
 * Body for POST /v1/files/:id/drive-link — mark this folder as the workspace's
 * sync root and bind it to a specific Google Drive folder (picked via Picker).
 *
 * `picker_account_email`, when present, is the Google account the browser used
 * to open Picker. The API rejects the link if it doesn't match the account that
 * authorised server-side OAuth — otherwise the worker (using a different
 * account's refresh token) couldn't see the picked folder and sync would
 * silently break.
 */
export const linkDriveFolderSchema = z.object({
    google_drive_folder_id: z.string().min(1).max(200),
    google_drive_folder_name: z.string().min(1).max(500),
    picker_account_email: z.string().email().max(320).optional(),
});
//# sourceMappingURL=google-drive.js.map